import { DEFAULT_PLAYER_OPTIONS } from 'src/services/shared/constants';
import videojs, { VideoJsPlayerOptions } from 'video.js';

interface IGetPlayerOptionsProps {
  enableLowInitialPlaylist?: boolean;
  limitRenditionByPlayerDimensions?: boolean;
  useDevicePixelRatio?: boolean;
  experimentalBufferBasedABR?: boolean;
}

class VideoJsConfigBuilder {
  config: VideoJsPlayerOptions;

  constructor() {
    this.config = DEFAULT_PLAYER_OPTIONS();
  }

  build() {
    return { ...this.config };
  }

  customRemoteConfig(customVHSConfig: IGetPlayerOptionsProps) {
    this.config.html5.vhs = {
      ...this.config.html5.vhs,
      ...customVHSConfig,
    };
    return this;
  }

  plugins(plugins: VideoJsPlayerOptions['plugins']) {
    this.config.plugins = plugins;
    return this;
  }

  withCredentials(isWithCredentials: boolean) {
    this.config.html5.vhs.withCredentials = isWithCredentials;
    return this;
  }

  sources(sources: videojs.Tech.SourceObject[]) {
    this.config.sources = sources;
    return this;
  }

  withEncryptedUrl(isWithEncryptedUrl: boolean) {
    this.config.html5.vhs.isEncryptedUrl = isWithEncryptedUrl;
    return this;
  }
}

export default VideoJsConfigBuilder;
